




import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DayCount extends Vue {
  @Prop() day!: number;

  get dayCount () {
    if (this.day === 0) {
      return '初夜'
    }

    return `${this.day}日目`
  }
}
